/* Nazik Home — silent English product+variant cart mapping for theme 2.
   Enabled by default in this unpublished theme, with a silent session opt-out.
   No popup, badges, overlays, or storefront text changes.
   Uses a separate limited production Edge Function. Express checkout
   and service load must still be checked before publication.
*/
(function(){
 "use strict";
 // ON by default in the unpublished theme. Session-only emergency opt-out:
 // ?nh_mail_prod_disable=1 disables, ?nh_mail_prod_disable=0 restores.
 try{
   var p=new URLSearchParams(location.search);
   if(p.get("nh_mail_prod_disable")==="1")sessionStorage.setItem("nh_mail_prod_disable","1");
   if(p.get("nh_mail_prod_disable")==="0")sessionStorage.removeItem("nh_mail_prod_disable");
   if(sessionStorage.getItem("nh_mail_prod_disable")==="1")return;
 }catch(_){/* Continue without sessionStorage */}
 var ENDPOINT="https://bodiptswpebwdgoosriz.supabase.co/functions/v1/nh-mail-en-lookup-prod";
 var ROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
 var nativeFetch=window.fetch.bind(window);
 var state={enabled:true,phase:"initializing",allReady:false,cartItems:0,lastRun:null,error:null};
 var running=null,pending=false,timer=null;
 window.NHMailEnProd={
   status:function(){return Object.assign({},state)},
   sync:function(){return synchronize()}
 };
 function numeric(x){var s=String(x||"");return /^[0-9]{10,17}$/.test(s)?s:null}
 async function cart(){
   var r=await nativeFetch(ROOT+"cart.js",{credentials:"same-origin",cache:"no-store"});
   if(!r.ok)throw Error("cart HTTP "+r.status);
   return r.json();
 }
 async function lookup(items){
   var all=[];
   for(var i=0;i<items.length;i+=5){
     var controller=new AbortController();
     var timeout=setTimeout(function(){controller.abort()},6500);
     try{
       var r=await nativeFetch(ENDPOINT,{
         method:"POST",mode:"cors",credentials:"omit",signal:controller.signal,
         headers:{"Content-Type":"application/json"},
         body:JSON.stringify({items:items.slice(i,i+5)})
       });
       var j=await r.json();
       if(!r.ok||!j||!j.ok||!Array.isArray(j.items))throw Error("English lookup HTTP "+r.status);
       all.push.apply(all,j.items);
     }finally{clearTimeout(timeout)}
   }
   return all;
 }
 async function update(){
   state.phase="reading";state.error=null;state.lastRun=new Date().toISOString();
   var before=await cart(),seen={},items=[];
   (before.items||[]).forEach(function(x){
     var pid=numeric(x.product_id),vid=numeric(x.variant_id);
     if(pid&&vid&&!seen[vid]){seen[vid]=true;items.push({product_id:pid,variant_id:vid})}
   });
   state.cartItems=items.length;
   var attrs=before.attributes||{};
   // Avoid repeated Shopify Admin translation lookups for an unchanged cart.
   // Refresh at most every 10 minutes; always check the exact product/variant IDs.
   var checkedAt=Number(attrs.nh_en_v4_checked_at)||0;
   var sameItems=items.length>0 &&
     attrs.nh_en_v4_ready==="1" &&
     attrs.nh_en_v4_count===String(items.length) &&
     checkedAt>0 && Date.now()-checkedAt>=0 &&
     Date.now()-checkedAt<600000 &&
     items.every(function(item){
       var product=attrs["nh_en_p_"+item.product_id];
       return typeof product==="string" && product.trim() &&
         Object.prototype.hasOwnProperty.call(attrs,"nh_en_v_"+item.variant_id);
     });
   if(sameItems){
     state.phase="ready_cached";state.allReady=true;
     return true;
   }
   var translated=items.length?await lookup(items):[];
   var mapped={},matched=0;
   translated.forEach(function(t){
     if(t&&t.ready&&t.variant_ready&&t.title_en){
       mapped["nh_en_p_"+t.product_id]=t.title_en;
       mapped["nh_en_v_"+t.variant_id]=t.variant_title_en||"";
       matched++;
     }
   });
   var ready=items.length>0&&matched===items.length;
   var changes=Object.assign({},mapped,{
     nh_en_v4_ready:ready?"1":"0",
     nh_en_v4_count:String(items.length),
     nh_en_v4_checked_at:ready?String(Date.now()):"0"
   });
   Object.keys(attrs).forEach(function(k){
     if((k.indexOf("nh_en_p_")===0||k.indexOf("nh_en_v_")===0)&&
       !Object.prototype.hasOwnProperty.call(mapped,k))changes[k]="";
   });
   var modified=Object.keys(changes).some(function(k){return String(attrs[k]||"")!==changes[k]});
   if(modified){
     state.phase="writing";
     var r=await nativeFetch(ROOT+"cart/update.js",{
       method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},
       body:JSON.stringify({attributes:changes})
     });
     if(!r.ok)throw Error("cart attributes HTTP "+r.status);
   }
   if(ready){
     var after=await cart();
     if(!Object.keys(mapped).every(function(k){return after.attributes&&after.attributes[k]===mapped[k]}))
       throw Error("cart attributes not verified");
   }
   state.allReady=ready;
   state.phase=ready?"ready":(items.length?"missing_translation":"empty_cart");
   return ready;
 }
 function synchronize(){
   if(running){pending=true;return running}
   running=update().catch(async function(err){
     state.phase="error";state.error=String(err&&err.message||err);
     state.allReady=false;
     // Fail closed for abandoned-checkout marketing: never reuse stale ready=1
     // after a fresh translation request failed. Checkout itself still proceeds.
     try{
       var r=await nativeFetch(ROOT+"cart/update.js",{
         method:"POST",credentials:"same-origin",
         headers:{"Content-Type":"application/json"},
         body:JSON.stringify({attributes:{nh_en_v4_ready:"0",nh_en_v4_checked_at:"0"}})
       });
       if(!r.ok)throw Error("fail closed attribute HTTP "+r.status);
     }catch(markErr){state.error+="; "+String(markErr&&markErr.message||markErr)}
     return false;
   }).finally(function(){
     running=null;
     if(pending){pending=false;schedule()}
   });
   return running;
 }
 function schedule(){
   if(timer!==null)clearTimeout(timer);
   timer=setTimeout(function(){timer=null;synchronize()},300);
 }
 function cartRequest(resource){
   var uri=typeof resource==="string"?resource:(resource&&resource.url)||"";
   try{return /\/cart\/(?:add|change|clear|update)\.(?:js|json)$/.test(new URL(uri,location.href).pathname)}
   catch(_){return false}
 }
 window.fetch=function(resource,init){
   var affects=cartRequest(resource);
   var promise=nativeFetch(resource,init);
   if(affects)promise.then(function(r){if(r.ok)schedule()}).catch(function(){});
   return promise;
 };
 var xhrOpen=XMLHttpRequest.prototype.open;
 XMLHttpRequest.prototype.open=function(method,uri){
   if(cartRequest(uri))this.addEventListener("loadend",function(){if(this.status>=200&&this.status<300)schedule()});
   return xhrOpen.apply(this,arguments);
 };
 async function beforeCheckout(next){
   // Never prevent checkout on missing translations or network errors.
   await Promise.race([synchronize(),new Promise(function(resolve){setTimeout(resolve,5000)})]);
   next();
 }
 document.addEventListener("click",function(e){
   var a=e.target&&e.target.closest&&e.target.closest("a[href]");
   if(!a||e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0)return;
   var url;
   try{url=new URL(a.href,location.href)}catch(_){return}
   if(url.origin!==location.origin||!/^\/checkout\/?$/.test(url.pathname))return;
   e.preventDefault();e.stopImmediatePropagation();
   beforeCheckout(function(){location.assign(a.href)});
 },true);
 document.addEventListener("submit",function(e){
   var form=e.target;
   if(!(form instanceof HTMLFormElement))return;
   var url;
   try{url=new URL(form.action,location.href)}catch(_){return}
   if(url.origin!==location.origin||!/^\/cart\/?$/.test(url.pathname))return;
   if(!(e.submitter&&e.submitter.name==="checkout")&&!form.querySelector('[name="checkout"]'))return;
   e.preventDefault();e.stopImmediatePropagation();
   beforeCheckout(function(){
     if(!form.querySelector('input[name="checkout"]')){
       var h=document.createElement("input");
       h.type="hidden";h.name="checkout";h.value="Checkout";form.appendChild(h);
     }
     HTMLFormElement.prototype.submit.call(form);
   });
 },true);
 window.addEventListener("pageshow",schedule);
 document.addEventListener("visibilitychange",function(){if(document.visibilityState==="visible")schedule()});
 window.addEventListener("focus",schedule);
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",schedule,{once:true});
 else schedule();
})();